import { Box, Tab, Tabs } from '@mui/material';
import React from 'react';

export type ReportTableTab = 'summary' | 'items';

type ReportTableTabsProps = {
    summaryLabel: string;
    itemsLabel: string;
    summaryContent: React.ReactNode;
    itemsContent: React.ReactNode;
    onTabChange?: (tab: ReportTableTab) => void;
};

export default function ReportTableTabs({
    summaryLabel,
    itemsLabel,
    summaryContent,
    itemsContent,
    onTabChange,
}: ReportTableTabsProps) {
    const [tab, setTab] = React.useState<ReportTableTab>('summary');

    const handleChange = (_: React.SyntheticEvent, value: ReportTableTab) => {
        setTab(value);
        onTabChange?.(value);
    };

    return (
        <Box sx={{ width: '100%', mt: 3 }}>
            <Tabs value={tab} onChange={handleChange}>
                <Tab value='summary' label={summaryLabel} />
                <Tab value='items' label={itemsLabel} />
            </Tabs>
            <Box sx={{ pt: 2 }}>
                {tab === 'summary' ? summaryContent : itemsContent}
            </Box>
        </Box>
    );
}
